import React from 'react';

const HashTagIcon = ({ width = '24', height = '24' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fluent:number-symbol-16-filled">
        <path
          id="Vector"
          d="M17.988 4.27972C18.0302 3.98434 17.9533 3.6843 17.7742 3.44561C17.6856 3.32743 17.5745 3.22786 17.4474
          3.1526C17.3202 3.07734 17.1795 3.02786 17.0333 3.00697C16.887 2.98609 16.738 2.99423 16.5949 3.03091C16.4518
          3.06759 16.3173 3.1321 16.1991 3.22075C15.9605 3.39981 15.8027 3.66634 15.7605 3.96173L15.2565
          7.50173H10.029L10.488 4.28422C10.5146 4.13551 10.511 3.98296 10.4774 3.83567C10.4438 3.68838 10.3809
          3.54936 10.2924 3.42692C10.2039 3.30448 10.0916 3.20111 9.96231 3.123C9.83299 3.04488 9.68927 2.99361
          9.53971 2.97224C9.39015 2.95088 9.23782 2.95986 9.09181 2.99864C8.94579 3.03742 8.80908 3.10522 8.68984
          3.19799C8.5706 3.29075 8.47126 3.40658 8.39775 3.53857C8.32424 3.67056 8.27808 3.81601 8.262 3.96623L7.755
          7.50023H5.625C5.32663 7.50003 5.0404 7.61836 4.82929 7.8292C4.61817 8.04004 4.49945 8.32611 4.49925
          8.62448C4.49905 8.92284 4.61739 9.20907 4.82822 9.42019C5.03906 9.63131 5.32513 9.75003 5.6235
          9.75023H7.434L6.792 14.2502H4.125C3.82663 14.2502 3.54048 14.3688 3.3295 14.5797C3.11853 14.7907 3 15.0769
          3 15.3752C3 15.6736 3.11853 15.9597 3.3295 16.1707C3.54048 16.3817 3.82663 16.5002 4.125
          16.5002H6.4725L6.0135 19.7162C5.99262 19.8625 6.00075 20.0114 6.03743 20.1545C6.07411 20.2977
          6.13862 20.4321 6.22728 20.5503C6.31594 20.6685 6.427 20.7681 6.55414 20.8434C6.68128 20.9186
          6.82199 20.9681 6.96825 20.989C7.11451 21.0099 7.26345 21.0017 7.40657 20.965C7.54968 20.9284
          7.68417 20.8639 7.80236 20.7752C7.92055 20.6865 8.02011 20.5755 8.09537 20.4483C8.17064 20.3212
          8.22012 20.1805 8.241 20.0342L8.745 16.5002H13.9725L13.5135 19.7162C13.4926 19.8625 13.5008 20.0114
          13.5374 20.1545C13.5741 20.2977 13.6386 20.4321 13.7273 20.5503C13.8159 20.6685 13.927 20.7681 14.0541
          20.8434C14.1813 20.9186 14.322 20.9681 14.4683 20.989C14.6145 21.0099 14.7634 21.0017 14.9066 20.965C15.0497
          20.9284 15.1842 20.8639 15.3024 20.7752C15.4205 20.6865 15.5201 20.5755 15.5954 20.4483C15.6706 20.3212
          15.7201 20.1805 15.741 20.0342L16.2465 16.5002H18.375C18.6734 16.5002 18.9595 16.3817 19.1705
          16.1707C19.3815 15.9597 19.5 15.6736 19.5 15.3752C19.5 15.0769 19.3815 14.7907 19.1705 14.5797C18.9595
          14.3688 18.6734 14.2502 18.375 14.2502H16.566L17.208 9.75023L19.875 9.75173C20.1734 9.75173 20.4595 9.6332
          20.6705 9.42222C20.8815 9.21124 21 8.92509 21 8.62673C21 8.32836 20.8815 8.04221 20.6705 7.83123C20.4595
          7.62025 20.1734 7.50173 19.875 7.50173H17.529L17.988 4.27972ZM14.9355 9.75173L14.2935 14.2502H9.066L9.708
          9.75023L14.9355 9.75173Z"
          fill="#003B58"
        />
      </g>
    </svg>
  );
};

export default HashTagIcon;
